import React, { useState } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import api from "../../../api";
import { fetchEmployee } from "./store/employeeSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const AddEmployee = ({ show, onClose, userId }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false); 
  const dispatch = useDispatch();

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleAddEmployee = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("import_file", file);
    setLoading(true); 

    try {
      const response = await api.post("/import-employee ", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        onClose(); 
        dispatch(fetchEmployee());
      } else {
        toast.error(response.data.message);
      }
      
    } catch (error) {
      console.log(error)      
      toast.error(error.response.data.message);
    } finally {
      setLoading(false); 
    }
  };

  const handleClose = () => {
    setFile(null); 
    setFileName(""); 
    onClose(); 
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
    <Modal.Title>{userId ? "Edit Employee" : "Add New Employee"}</Modal.Title>
    <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={handleClose}
        style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            background: "transparent",
            border: "none",
            fontSize: "1.25rem",
        }}
    >
        &times;
    </button>
</Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formFile" className="mb-4">
          <Form.Label style={{ fontWeight: "500", fontSize: "1rem" }}>Upload Employee File</Form.Label>
          <Form.Control 
            type="file"
            accept=".csv"
            onChange={handleFileUpload}
          />
          {fileName && <small className="text-muted mt-2">Selected File: {fileName}</small>}
        </Form.Group>
        
        <div className="d-flex justify-content-end mt-3">
          <Button
            variant="primary"
            onClick={handleAddEmployee}
            disabled={!file || loading}
            style={{ minWidth: "150px" }} // Keep button width consistent
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2" // Add margin to the right
              />
            )}
            {userId ? "Update Employee" : "Add Employee"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEmployee;
